const PARAGRAPH_BASIC_BLOCK = (uuid: string, language: string) => `
  blockDataUUID(uuid: "${uuid}", language: "${language}") {
    type
    uuid
    ... on BasicBlock {
      id
      body
      header
      hideForUsers
      iconBlock
      title
      type
      uuid
    }
  }
`;

export default PARAGRAPH_BASIC_BLOCK;
